export enum DashboardUseCase {
  Default = 'DEFAULT',
  Search = 'SEARCH',
}
